"use client";

import { useEffect, useState } from "react";

export default function Footer() {
  const [year, setYear] = useState<number | string>("");

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  return (
    <footer className="w-full py-6 mt-auto border-t border-border bg-background">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm text-muted-foreground">
          &copy; {year || "2026"} Real Pilot. All rights reserved.
        </p>
        <p className="text-xs text-muted-foreground/60 mt-1">
          Das Cockpit für dein Immobilienvermögen
        </p>
      </div>
    </footer>
  );
}
